module.exports = __webpack_public_path__ + "static/media/momo-logo-from-mtn.98c4d640.png";